import { BuildingEquipmentItemDto, EquipmentItemDto } from '@artemis-software/wr-api';

/** Natural ("alphanumeric") ordering: "Reiterstraße, 2" sorts before "Reiterstraße, 10". */
export const naturalCollator = new Intl.Collator('de', { numeric: true, sensitivity: 'base' });

export interface BuildingEquipmentTypeGroup {
  equipment: EquipmentItemDto;
  items: BuildingEquipmentItemDto[];
  totalQuantity: number;
}

/**
 * Groups building equipments by TGA type, keyed on `equipment.id` — equipment names are not
 * unique across tenants, so grouping by name would merge distinct types into one colour.
 * Preserves the input order, i.e. the caller decides how groups and items are sorted.
 */
export function groupBuildingEquipmentsByType(
  items: readonly BuildingEquipmentItemDto[],
): BuildingEquipmentTypeGroup[] {
  const groups = new Map<string, BuildingEquipmentTypeGroup>();
  for (const item of items) {
    let group = groups.get(item.equipment.id);
    if (!group) {
      group = { equipment: item.equipment, items: [], totalQuantity: 0 };
      groups.set(item.equipment.id, group);
    }
    group.items.push(item);
    group.totalQuantity += item.quantity;
  }
  return Array.from(groups.values());
}
